import { readConfigFile } from "utils/appConfig";

let kcConfig;

export const initializeKCConfig = async () => {
  try {
    const config = await readConfigFile();
    const clientId = config.VITE_KC_CLIENT_ID || "";
    const environment = config.VITE_KC_ENVIRONMENT || "";
    const redirectUri = config.VITE_YMS_WEBSITE || "";
    kcConfig = {
      clientId: clientId,
      environment: environment,
      redirectUri: redirectUri,
    };
  } catch (error) {
    console.error("Erro ao obter configuração do KC:", error);
    throw error;
  }
};

export const getUrlKeyClock = async () => {
  await initializeKCConfig();
  const keyClockUrl = `https://${kcConfig.environment}.com.br/realms/Ambev/protocol/openid-connect/auth?response_type=code&client_id=${kcConfig.clientId}&redirect_uri=${kcConfig.redirectUri}/signin&scope=openid&prompt=login`;
  return keyClockUrl;
};

export const getUrlKeycloakLogout = async (idTokenHint?: string) => {
  await initializeKCConfig();
  const postLogoutRedirectUri = `${kcConfig.redirectUri}/multiple-realms`;
  const idTokenHintQueryParam = idTokenHint ? `&id_token_hint=${encodeURIComponent(idTokenHint)}` : "";
  return `https://${kcConfig.environment}.com.br/realms/Ambev/protocol/openid-connect/logout?client_id=${encodeURIComponent(
    kcConfig.clientId
  )}${idTokenHintQueryParam}&post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
};
